import React from "react";
import "./skeleton.css";

const TemplateSkeleton = () => {
  return (
    <div className="tplCard tplCardSkeleton flex-shrink-0" aria-hidden="true">
      <div className="tplCardSkeleton__badge skeleton-shimmer" />
      <div className="tplCardBody">
        <div className="tplCardSkeleton__title skeleton-shimmer" />
        <div className="tplCardSkeleton__desc skeleton-shimmer" />
        <div className="tplCardSkeleton__desc tplCardSkeleton__desc--short skeleton-shimmer" />
      </div>
    </div>
  );
};

export default TemplateSkeleton;
